import type { ReactNode } from 'react'
import { ActionPopup } from 'components/Popup/ActionPopup'

export function MissingPhotosPopup({
  open,
  popupName,
  thumbnail,
  title,
  subtitle,
  ctaText,
  analyticsProps,
  onDismiss,
  onApprove,
}: {
  open: boolean
  popupName: string
  thumbnail: ReactNode
  title: string
  subtitle?: string
  ctaText: string
  analyticsProps: Record<string, unknown>
  onDismiss: () => void
  onApprove: () => void
}) {
  return (
    <ActionPopup
      popupName={popupName}
      open={open}
      imageComponent={thumbnail}
      showCloseButton
      onClose={onDismiss}
      mainText={title}
      secondaryText={subtitle}
      approveText={ctaText}
      onApproveTap={onApprove}
      analyticsProps={analyticsProps}
      titleMaxWidth={300}
    />
  )
}
